import React from 'react';
import { delimited } from '../../../common/utils/commonUtil';
import ColorArrowPng from '../../../../assets/images/views/questions/color-arrow.png';
import WhArrowPng from '../../../../assets/images/views/questions/wh-arrow.png';
import {
  type AngelTaxResult,
  toDisplayAmount,
} from '../../models/questions/angelTaxCalculator';
import AngelTaxResultCard from './angelTaxResultCard';
import AngelTaxProjectsSection from './angelTaxProjectsSection';

interface Props {
  // 計算前は null
  result: AngelTaxResult | null;
  projectsPath: string;
}

export default function AngelTaxResultView({ result, projectsPath }: Props) {
  if (result == null) return null;
  const displayIncomeTax = toDisplayAmount(result.incomeTax);

  return (
    // .content の幅を超えて画面いっぱいに敷く。上端中央の白い切り欠きは画像（@2x）
    <div className="tw:relative tw:mx-[calc(50%-50vw)] tw:flex tw:flex-col tw:items-center tw:gap-12 tw:bg-(--angel-tax-accent-surface) tw:px-4 tw:pt-20 tw:pb-10 tw:md:gap-20 tw:md:px-6 tw:md:py-20">
      <img
        src={WhArrowPng}
        width="201"
        height="48"
        alt=""
        className="tw:absolute tw:top-0 tw:left-1/2 tw:w-25 tw:-translate-x-1/2 tw:md:w-auto"
      />
      <div className="tw:flex tw:w-full tw:max-w-245 tw:flex-col tw:items-center tw:gap-6 tw:md:gap-10">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-3 tw:md:gap-4">
          <h2 className="tw:m-0 tw:text-center tw:text-xl tw:leading-normal tw:font-semibold tw:tracking-text tw:md:text-3xl">
            シミュレーション結果
          </h2>
          <div className="tw:flex tw:flex-col tw:items-center tw:gap-1.5 tw:md:gap-2">
            <p className="tw:m-0 tw:font-noto tw:text-sm tw:leading-[1.7] tw:font-medium tw:tracking-text tw:md:text-base tw:md:font-bold">
              エンジェル税制
              <span className="tw:text-(--angel-tax-accent)">
                未使用の場合の所得税額
              </span>
            </p>
            <p className="tw:m-0 tw:text-sm tw:leading-normal tw:font-semibold tw:tracking-text tw:md:text-base">
              {`${delimited(displayIncomeTax)}円`}
            </p>
          </div>
          <img src={ColorArrowPng} width="106" height="26" alt="" />
        </div>
        {/* Figma の Frame 35。結果カード 3 枚と免責文を 20px 間隔で積む */}
        <div className="tw:flex tw:w-full tw:flex-col tw:gap-5">
          <AngelTaxResultCard
            tone="a"
            title="優遇措置A"
            deductionNote="(投資額−2,000)をその年の総所得金額等から控除"
            limitNote="800万円と総所得金額×40%のいずれか低い方"
            disposal="taxDeferral"
            angelTax={result.angelTaxA}
          />
          <AngelTaxResultCard
            tone="b"
            title="優遇措置B"
            deductionNote="投資額をその年の株式譲渡益から控除"
            limitNote="なし"
            disposal="taxDeferral"
            angelTax={result.angelTaxB}
          />
          <AngelTaxResultCard
            tone="pre-seed"
            title="プレシード・シード特例"
            deductionNote="投資額をその年の株式譲渡益から控除"
            limitNote="なし"
            disposal="taxExempt"
            angelTax={result.angelTaxPreSeed}
          />
          <p className="tw:m-0 tw:text-xs tw:leading-normal tw:tracking-text tw:text-muted-foreground">
            本エンジェル税制税負担軽減シミュレーターは、税務申告に使用する為ではなく、仮定条件に基づく概算額の試算やそれに基づく情報提供を唯一の目的としています。実際の申告や各種株式の取得または譲渡等、プラン実行の際には、税理士等の専門家にご相談下さい。
          </p>
        </div>
      </div>
      <AngelTaxProjectsSection projectsPath={projectsPath} />
    </div>
  );
}
